import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/loginIndex.vue'),
  },
  {
    path: '/',
    name: 'main',
    component: () => import('@/views/layout/layoutIndex.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',//首页
        name: 'home',
        component: () => import('@/views/home/homeIndex.vue'),
      },
      {
        path: '/enterprise',//企业信息
        name: 'enterprise',
        component: () => import('@/views/enterprise/qyIndex.vue'),
      },
      {
        path: '/expenseMgt',//费用管理
        name: 'expenseMgt',
        component: () => import('@/views/expenseMgt/expenseMenu.vue'),
        redirect: '/expenseMgt/personnel',
        children: [
          {
            path: '/expenseMgt/personnel',//人员
            name: 'personnel',
            component: () => import('@/views/expenseMgt/personnel/personnelTabs.vue'),
          },
          {
            path: '/expenseMgt/rawMaterial',//原材料
            name: 'rawMaterial',
            component: () => import('@/views/expenseMgt/rawMaterial/rawMaterial.vue'),
          },
          {
            path: '/expenseMgt/gdzc',//固定资产
            name: 'gdzc',
            component: () => import('@/views/expenseMgt/gdzc/gdzcTabs.vue'),
          },
          {
            path: '/expenseMgt/wxzc',//无形资产
            name: 'wxzc',
            component: () => import('@/views/expenseMgt/wxzc/wxzcTabs.vue'),
          },
          {
            path: '/expenseMgt/designFee',//设计费用
            name: 'designFee',
            component: () => import('@/views/expenseMgt/fourInOne/fourInOne.vue'),
          },
          {
            path: '/expenseMgt/equipmentFee',//装备调试费
            name: 'equipmentFee',
            component: () => import('@/views/expenseMgt/fourInOne/fourInOne.vue'),
          },
          {
            path: '/expenseMgt/otherFee',//其他费用
            name: 'otherFee',
            component: () => import('@/views/expenseMgt/fourInOne/fourInOne.vue'),
          },
          {
            path: '/expenseMgt/outFee',//委外费用
            name: 'outFee',
            component: () => import('@/views/expenseMgt/fourInOne/fourInOne.vue'),
          },
        ]
      },
      {
        path: '/IP',//知识产权
        name: 'IP',
        component: () => import('@/views/IP/ipMenu.vue'),
        redirect: '/IP/ipIndex',
        children: [
          {
            path: '/IP/ipIndex',//ip全部相关
            name: 'ipIndex',
            component: () => import('@/views/IP/IPAll/IPTabs.vue'),
          },
          {
            path: '/IP/standard',//标准信息
            name: 'standard',
            component: () => import('@/views/IP/standard/standardInfo.vue'),
          },
        ]
      },
      {
        path: '/ST',//科技成果
        name: 'ST',
        component: () => import('@/views/ST/STIndex.vue'),
      },
      {
        path: '/PS',//高新产品
        name: 'PS',
        component: () => import('@/views/PS/PSIndex.vue'),
      },
      {
        path: '/RD',//研发项目
        name: 'RD',
        component: () => import('@/views/RD/RDIndex.vue'),
      },
      {
        path: '/yfChart',//研发体系
        name: 'yfChart',
        component: () => import('@/views/research/yfIndex.vue'),
      },
      {
        path: '/yfExpense',//研发费用
        name: 'yfExpense',
        component: () => import('@/views/yfExpense/yfTabs.vue'),
      },
      {
        path: '/template',//制度管理
        name: 'template',
        component: () => import('@/views/template/templateMenu.vue'),
        redirect: '/template/system',
        children: [
          {
            path: '/template/system',//ip全部相关
            name: 'system',
            component: () => import('@/views/template/system/systemPage.vue'),
          },
          {
            path: '/template/honor',//标准信息
            name: 'honor',
            component: () => import('@/views/template/honor/honorPage.vue'),
          },
        ]
      },
      {
        path: '/shenji',//制度管理
        name: 'shenji',
        component: () => import('@/views/shenji/templateMenu.vue'),
        redirect: '/shenji/nianshen',
        children: [
          {
            path: '/shenji/nianshen',//年审
            name: 'NS',
            component: () => import('@/views/shenji/nianshen/nsTabs.vue'),
          },
          // {
          //   path: '/template/zhuanshen',//专审
          //   name: 'ZS',
          //   component: () => import('@/views/template/honor/zsPage.vue'),
          // },
        ]
      },
      {
        path: '/admin',//制度管理
        name: 'admin',
        component: () => import('@/views/admin/templateMenu.vue'),
        redirect: '/admin/company',
        children: [
          {
            path: '/admin/company',//年审
            name: 'ADMIN',
            component: () => import('@/views/admin/company/companyPage.vue'),
          },
          // {
          //   path: '/template/zhuanshen',//专审
          //   name: 'ZS',
          //   component: () => import('@/views/template/honor/zsPage.vue'),
          // },
        ]
      },
      {
        path: '/nsPage',//研发费用
        name: 'nsPage',
        component: () => import('@/views/shenji/nianshen/nsPage.vue'),
      },
    ]
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
